import { DepositForAccount } from "@mezo/api"
import { SupportedTokenName } from "@mezo/sdk"

import {
  BASE_DAILY_MATS,
  MATS_MULTIPLIER,
  MAX_DISPLAYED_MATS,
  STABLECOINS_MATS_MULTIPLIER,
  STBTC_TOKENS_MATS_MULTIPLIER,
  SUPERSTACK_MATS_FACTOR,
} from "#/shared/constants"

import { separateThousandsWithComma } from "./numbers"
import { isStablecoin, isStbtcToken } from "./token"

export const SPECIAL_MULTIPLIER_STABLECOINS: Partial<
  Record<SupportedTokenName, { multiplier: number; dailyMats: number }>
> = {
  T: { multiplier: 0.0005, dailyMats: 20 },
}

export const calculateDailyMats = (
  depositAmount: string,
  multiplier: number,
  token: SupportedTokenName,
) => {
  let matsMultiplier = MATS_MULTIPLIER
  const specialCase = SPECIAL_MULTIPLIER_STABLECOINS[token]

  if (specialCase) {
    matsMultiplier = specialCase.multiplier
  } else if (isStablecoin(token)) {
    matsMultiplier = STABLECOINS_MATS_MULTIPLIER
  } else if (isStbtcToken(token)) {
    matsMultiplier = STBTC_TOKENS_MATS_MULTIPLIER
  }

  return Math.floor(Number(depositAmount) * multiplier * matsMultiplier)
}

export const getBaseDailyMats = (token: SupportedTokenName): number => {
  const specialCase = SPECIAL_MULTIPLIER_STABLECOINS[token]

  if (specialCase) {
    return specialCase.dailyMats
  }

  if (isStablecoin(token)) {
    return BASE_DAILY_MATS.stablecoin
  }

  if (isStbtcToken(token)) {
    return BASE_DAILY_MATS.stbtc
  }

  return BASE_DAILY_MATS.default
}

export const formatMats = (mats: number, plusSign: boolean = true) => {
  const parsedMats =
    mats > MAX_DISPLAYED_MATS
      ? "1M"
      : separateThousandsWithComma(Math.round(mats), 0)

  const formattedMats = plusSign ? `+${parsedMats}` : parsedMats

  return mats < 1 ? "<1" : formattedMats
}

export const calculatePotentialSuperstackMats = (
  deposits: DepositForAccount[],
) => {
  // TODO: exclude mats that are already used in stBTC minting process
  const dailyMats = deposits.map((deposit) => deposit.dailyMats)

  /**
   * Superstack mats are calculated using formula:
   * The daily mat rate from the eligible tBTC and wBTC deposits which are
   * not yet used for stBTC minting) * 110%
   */
  return SUPERSTACK_MATS_FACTOR * dailyMats.reduce((a, b) => a + b)
}
